import { StockItem } from '@anm/api/modules/stocks';
import { WAVE_EDITOR } from '@anm/constants/wave-editor';
import isId from '@anm/helpers/is/isId';
import { toUrlParams } from '@anm/helpers/parseParams';
import { b64EncodeUnicode } from '@anm/helpers/string/base64';
import usePageParams from '@anm/hooks/usePageParams';
import { useCallback } from 'react';

import vtConfig from '../../../config';

const { urls } = vtConfig();

export const useAddStock = (selectedStock: StockItem, onAddStock: () => void) => {
  const handleAddStock = useCallback(() => {
    window.parent.postMessage(
      {
        target: WAVE_EDITOR,
        stockInfo: selectedStock
      },
      '*'
    );
    onAddStock();
  }, [selectedStock]);

  return handleAddStock;
};

export const useTemplateFromStockUrl = (selectedStock: StockItem) => {
  const { folderId, embed } = usePageParams();
  const strStock = JSON.stringify(selectedStock);
  const isEmbedId = isId(embed);

  const params = {
    ...(isEmbedId && { embed }),
    ...(folderId && { folderId }),
    new: b64EncodeUnicode(strStock)
  };
  const urlParams = toUrlParams(params, false);

  const stockUrl = `${urls.editor}/#${urlParams}`;

  return stockUrl;
};
